// Het funding-blok onder "Opleiding" in het skill-detail.
//
// W5 (fase 1, S4) zette hier de lijst van open regelingen voor de sector;
// fase 5 (F5 a + G4 a, ADR docs/decisions/2026-10-06-funding-werkend.md)
// vervangt die lijst door de regelingenstrook: dezelfde ene route
// (GET /api/funding/voor) als trend-detail en de Plan-tab, drie regelingen op
// pasmaat, de doelgroep-eis als subregel en "alle N op de Funding-tab".
//
// WAT DIT WEL EN NIET IS. Een regeling financiert scholing in het algemeen,
// niet een bepaalde vaardigheid; binnen de sector past elke open regeling bij
// elke skill. Dit blok kijkt dus alleen naar de SECTOR van de skill — een
// afgeleide suggestie (de lezer ziet "Kansrijk" met uitleg, Kansrijk.tsx), geen
// oordeel over de situatie van de lezer. Nooit een
// tekstmatch op de skillnaam, nooit een percentage.
//
// SECTORLOGICA (ongewijzigd sinds W5, ownerbesluit 8): `skill.sector` is het
// V1-weergavelabel; alleen een eenduidige vertaling naar een sleutel uit
// sectors.yaml telt. 'Techniek' heeft die niet (ownervraag): dan alleen de
// sectorbrede regelingen, met een zin die dat zegt.

import type { Skill } from "../contracts";
import { RegelingenStrook, SECTOR_SLEUTEL, SECTORBREED } from "./RegelingenStrook";
import { color, size, weight } from "../tokens";

export { SECTOR_SLEUTEL, SECTORBREED };

export function SkillRegelingen({ sector }: { sector: Skill["sector"] }) {
  const sleutel = SECTOR_SLEUTEL[sector] ?? null;
  return (
    <div data-testid="skill-regelingen">
      <div style={{ fontSize: size.meta, fontWeight: weight.medium, color: color.ink, marginBottom: 4 }}>
        Funding
      </div>
      <RegelingenStrook
        sector={sleutel ?? SECTORBREED}
        sectorLabel={sector}
        toelichting={
          sleutel ? undefined : (
            <>
              Het label “{sector}” heeft nog geen eenduidige sector in de Funding-tab; daarom
              alleen de sectorbrede.
            </>
          )
        }
      />
    </div>
  );
}
